import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { ReactSession } from 'react-client-session';
import useWeb3 from '../../hooks/useWeb3'; 
import Web3 from 'web3'
import Header from '../../components/Header'; 
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleArrowLeft} from '@fortawesome/free-solid-svg-icons';
import {ContractInfo, IsCreatedHere} from '../../hooks/useContractFactory';
import { Link, useParams } from 'react-router-dom';
import { 
    mint , 
    Approve , 
    Transfer, 
    TransferOwner, 
    ExcludeFromFee, 
    IncludeInFee,
    SetBurnFee,
    SetLiqFee,
    SetMarketingFee,
    SetTaxFee,
    SetMarketingWallet

} from '../../utils/contractCalls';
import { useStandardTokenMintableContract  , useLiquidityGeneratorContract ,useLiquidityGeneratorBurnableContract} from '../../hooks/useContracts';
import Footer from '../../components/Footer';


function Edit() {

     const {account} = useWallet();

     const { walletaddr } = useParams();

     const isCreated = IsCreatedHere(walletaddr);
      

     if(!isCreated){
        window.location="/tokenmanage";
     }
 
     const Load = styled.div`
     width: 45px;
     height: 45px;
     border-radius: 50%;
     border: 6px solid #0000;
     border-right-color: #86FF00;
     position: relative;
     animation: s4 1s infinite linear;

     &:after {
        content: "";
    position: absolute;
    inset:-4px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
    animation-duration: 4s;
      }

      @keyframes s4 {
        100% {transform: rotate(1turn)}
      }
       `;
 

        const Info = ContractInfo(walletaddr);
        

        const [mintAccount,setmintAccount] = useState("");
        const [mintAmount,setmintAmount] = useState("");

        

        const mintablecontract = useStandardTokenMintableContract(walletaddr);
        const liquiditygeneratorcontract = useLiquidityGeneratorContract(walletaddr);
        const liquiditygeneratorburncontract = useLiquidityGeneratorBurnableContract(walletaddr);

        const [approveAddress,setapproveAddress] = useState("");
        const [approveAmount,setapproveAmount] = useState("");

        const [transferAddress,settransferAddress] = useState("");
        const [transferAmount,settransferAmount] = useState("");

    
        const [owner,setOwner] = useState("");

        const [excludeFromFeeAddress,setexcludeFromFeeAddress] = useState("");
        const [includeInFeeAddress,setincludeInFeeAddress] = useState("");

        const [taxFeePercent,settaxFeePercent] = useState("");
        const [burnFeePercent, setburnFeePercent] = useState("");
        const [liqFeePercent,setliqFeePercent] = useState("");
        const [marketingFeePercent,setmarketingFeePercent] = useState("");

        const [marketingWallet,setmarketingWallet] = useState("");


       const setmarketingWalletClick = ()=>{
        SetMarketingWallet(liquiditygeneratorburncontract,marketingWallet,account).then((e)=>{
            toast.success("Success.");
        }).catch((e)=>{
            console.log(e)
            if(e.code == 4001){
                toast.error("Canceled");
            }else{
                toast.error("Params Error");
            }
        });
       }


        const setTaxFeeOnclick =()=>{
            SetTaxFee(liquiditygeneratorburncontract,taxFeePercent,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }

        const setmarketingFeeOnclick =()=>{
            SetMarketingFee(liquiditygeneratorburncontract,marketingFeePercent,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }

        const setliqFeeOnclick=()=>{
            SetLiqFee(liquiditygeneratorburncontract,liqFeePercent,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }

        const setBurnFeeOnclick=()=>{
            SetBurnFee(liquiditygeneratorburncontract,burnFeePercent,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }


        const includeinfeeClick =()=>{
            IncludeInFee(liquiditygeneratorburncontract,includeInFeeAddress,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }

        const excludeFromFeeClick = () =>{
            ExcludeFromFee(liquiditygeneratorburncontract,excludeFromFeeAddress,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
            });
        }
        
        
        const mintToken = ()=>{
            mint(mintablecontract,mintAccount,mintAmount,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
               
            });
        }

        const approveContract= () =>{
            Approve(mintablecontract,approveAddress,approveAmount,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
               
            });
        }

  
        const transferToken = () =>{
             Transfer(mintablecontract,transferAddress,transferAmount,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
               
            });
        }

        const transferOwnership = () =>{
            TransferOwner(mintablecontract,owner,account).then((e)=>{
                toast.success("Success.");
            }).catch((e)=>{
                console.log(e)
                if(e.code == 4001){
                    toast.error("Canceled");
                }else{
                    toast.error("Params Error");
                }
               
            })
        }

        const addTokenToMetamask = async () => {
             
              const wasAdded = await window.ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                  type: 'ERC20',  
                  options: {
                    address: walletaddr,  
                    symbol: Info.tokenInfo.symbol,  
                    decimals: Info.tokenInfo.decimal, 
                    image: "", 
                  },
                },
              });

              if (wasAdded) {
                toast.success("Added Token");
                console.log('Added Token!');
              } 
             
          };
    
     return ( 
     <>
    <div id="wrapper">
      <Header />
      
      <section className="tf-section tf-wallet" >
        <div style={{maxWidth:"760px"}} className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="wallet-form">
                <div className='row'>
                    <div className="col-lg-6">
                        <div className="wrap-btn">
                         <Link to="/tokenmanage" className="tf-button style2 w-10">
                            <FontAwesomeIcon icon={faCircleArrowLeft} style={{marginRight:"5px"}} />  Back 
                         </Link>
                        </div>
                    </div>
                     
                </div>
                <hr/>
                
                <h4>Edit Token</h4>
                ({Info.tokenType ==1 ? "Standard Token" : Info.tokenType ==2 ? "Standard Mintable Token" : Info.tokenType == 3 ? "Liquidity Generator Token" : "Liquidity Generator + Burnable Token"})
                    <center><a target={"_blank"} href={ReactSession.get("network").blockexplorer+'/address/'+ walletaddr}> {walletaddr} </a>
                    <br/> <br/>
                        <button onClick={addTokenToMetamask} className="tf-button style2 w-10">  <img className='mr-4' width={25} src='https://cdn.iconscout.com/icon/free/png-512/metamask-2728406-2261817.png' /> ADD METAMASK</button>
                    </center>
                     
                    
                     
                <hr/>
                <div className="choose-network flat-tabs">
                    <h6>Your Created Tokens</h6>
                    
                    {Info.tokenInfo ? (

                        <div className='row'>
                              {Info.detail.owner == account ? null : (<div className='alert alert-danger'>You are not a Contract Owner. so you can't edit.</div>)}
                        <div className="col-md-12">
                           <div className="tokenomics-wrapper aos-init aos-animate" data-aos="fade-up"  >
                               <div className='row'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Name:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" readOnly value={Info.tokenInfo.name} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                        
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Symbol:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" readOnly value={Info.tokenInfo.symbol} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                        
                                   </div>
                               </div>
                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Decimal:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" readOnly value={Info.tokenInfo.decimal} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                        
                                   </div>
                               </div>
                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Total Supply:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" readOnly value={Info.tokenInfo.totalsupply/10**Info.tokenInfo.decimal} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                        
                                   </div>
                               </div>
                            {Info.tokenType == 3 || Info.tokenType == 4  ? (<>
                                <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Max Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" readOnly value={Info.detail.maxFee} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                        
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Marketing Wallet:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" value={Info.detail.marketingWallet} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                      Set Wallet:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text"  value={marketingWallet} onChange={(e)=>{setmarketingWallet(e.target.value)}} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={setmarketingWalletClick} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>
 
                                
                                {Info.tokenType == 4 ? (
                                    <div className='row mt-3'>
                                    <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                        <span>
                                        Burn Fee:
                                        </span>
                                    </div>
                                    <div className='col-lg-1' style={{paddingTop:"12px"}}>
                                        <span>
                                        {Info.detail.burnFee}%
                                        </span>
                                    </div>
                                    <div className='col-lg-7'>
                                         <input type="text" placeholder='fee (uint256)' value={burnFeePercent} onChange={(e)=>{setburnFeePercent(e.target.value)}} required style={{background:"#171F29"}} />
                                    </div> 
                                    <div className='col-lg-2'>
                                     <button type="submit" onClick={setBurnFeeOnclick} class="tf-button style2 w-100" >Edit</button>
                                    </div>
                                </div>
                                ) : null}
                               



                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Liq Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-1' style={{paddingTop:"12px"}}>
                                       <span>
                                       {Info.detail.liqFee}%
                                       </span>
                                   </div>
                                   <div className='col-lg-7'>
                                        <input type="text" placeholder='fee (uint256)' value={liqFeePercent} onChange={(e)=>{setliqFeePercent(e.target.value)}} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button onClick={setliqFeeOnclick} type="submit" class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>
                          
                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                         Marketing Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-1' style={{paddingTop:"12px"}}>
                                       <span>
                                       {Info.detail.marketingFee}%
                                       </span>
                                   </div>
                                   <div className='col-lg-7'>
                                        <input type="text" placeholder='fee (uint256)' value={marketingFeePercent} onChange={(e)=>{setmarketingFeePercent(e.target.value)}} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={setmarketingFeeOnclick}  class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Tax Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-1' style={{paddingTop:"12px"}}>
                                       <span>
                                       {Info.detail.taxFee}%
                                       </span>
                                   </div>
                                   <div className='col-lg-7'>
                                        <input type="text" placeholder='fee (uint256)' value={taxFeePercent} onChange={(e)=>{settaxFeePercent(e.target.value)}} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={setTaxFeeOnclick} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>
 
                               <div className='row mt-3'>
                                   <div className='col-lg-2'  style={{paddingTop:"12px"}}>
                                       <span>
                                       exclude From Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" value={excludeFromFeeAddress} onChange={(e)=>{setexcludeFromFeeAddress(e.target.value)}} placeholder='account (address)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={excludeFromFeeClick} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       include In Fee:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" value={includeInFeeAddress} onChange={(e)=>{setincludeInFeeAddress(e.target.value)}} placeholder='account (address)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={includeinfeeClick} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       uniswap V2 Router:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" value={Info.detail.uniswapV2Router} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                     
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       uniswap V2 Pair:
                                       </span>
                                   </div>
                                   <div className='col-lg-8'>
                                        <input type="text" value={Info.detail.uniswapV2Pair} required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                     
                                   </div>
                               </div>


                               {Info.tokenType == 4 ? (
                                <div className='row mt-3'>
                                <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                    <span>
                                    dead Address:
                                    </span>
                                </div>
                                <div className='col-lg-8'>
                                     <input type="text" value={Info.detail.deadAddress} required style={{background:"#171F29"}} />
                                </div> 
                                <div className='col-lg-2'>
                                  
                                </div>
                            </div>
                               ) : null }
                               
 
                            </>) : null}

                            <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                        Owner:
                                       </span>
                                   </div>
                                   
                                   <div className='col-lg-8'>
                                    <input type="text" readOnly value={Info.detail.owner} placeholder='newOwner (address)' required style={{background:"#171F29"}} />
                                        
                                   </div> 
                                   <div className='col-lg-2'>
                                   
                                   </div>
                               </div>
                               
 
                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       Transfer Ownership:
                                       </span>
                                   </div>
                                   
                                   <div className='col-lg-8'>
                                        <input type="text" value={owner} onChange={(e)=>{setOwner(e.target.value)}} placeholder='newOwner (address)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={transferOwnership} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>           
            
                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       transfer:
                                       </span>
                                   </div>
                                   <div className='col-lg-4'>
                                        <input type="text" value={transferAddress} onChange={(e)=>settransferAddress(e.target.value)} placeholder='recipients (address)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-4'>
                                        <input type="text" value={transferAmount} onChange={(e)=>settransferAmount(e.target.value)} placeholder='amount (uint256)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={transferToken} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div>

                               <div className='row mt-3'>
                                   <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                       <span>
                                       approve:
                                       </span>
                                   </div>
                                   <div className='col-lg-4'>
                                        <input type="text" value={approveAddress} onChange={(e)=>setapproveAddress(e.target.value)} placeholder='spender (address)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-4'>
                                        <input type="text" value={approveAmount} onChange={(e)=>setapproveAmount(e.target.value)} placeholder='amount (uint256)' required style={{background:"#171F29"}} />
                                   </div> 
                                   <div className='col-lg-2'>
                                    <button type="submit" onClick={approveContract} class="tf-button style2 w-100" >Edit</button>
                                   </div>
                               </div> 
                                {Info.tokenType == 2 ? (
                                    <div className='row mt-3'>
                                    <div className='col-lg-2' style={{paddingTop:"12px"}}>
                                        <span>
                                        mint:
                                        </span>
                                    </div>
                                    <div className='col-lg-4'>
                                         <input type="text" placeholder='account (address)' value={mintAccount} onChange={(e)=>{setmintAccount(e.target.value)}} required style={{background:"#171F29"}} />
                                    </div> 
                                    <div className='col-lg-4'>
                                         <input type="text" placeholder='amount (uint256)' value={mintAmount} onChange={(e)=>{setmintAmount(e.target.value)}} required style={{background:"#171F29"}} />
                                    </div> 
                                    <div className='col-lg-2'>
                                     <button type="submit" onClick={mintToken} class="tf-button style2 w-100" >Edit</button>
                                    </div>
                                </div> 
                                ) : null}

                           </div>
                       </div>
                        </div>
                    ) : (<center><Load/> Loading...</center>)}
                     
                  </div>
                    <div className="bottom">
                         
                    </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </> ); 

} 

export default Edit;